package com.ijoin.data.model

fun Event.isFreeEvent(): Boolean {
    val minTierPrice = priceTiers?.minOfOrNull { it.price }
    val effectivePrice = minTierPrice ?: ticketPrice
    return effectivePrice == null || effectivePrice <= 0.0
}
